module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs is-fullwidth is-centered"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.name,
      class: {
        'is-active': tab.isActive
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tabs-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217c3820","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabsComponent/Tabs.vue
// module id = 2113
// module chunks = 1